// extracted by mini-css-extract-plugin
module.exports = {"link":"LinksContainer_link__3n-Sm","selected":"LinksContainer_selected__3Jeg0"};